/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogoutCommand
 */
export interface LogoutCommand {
    /**
     * 
     * @type {string}
     * @memberof LogoutCommand
     */
    idToken: string;
    /**
     * 
     * @type {string}
     * @memberof LogoutCommand
     */
    authorizationHeader: string;
    /**
     * 
     * @type {string}
     * @memberof LogoutCommand
     */
    authMethod: string;
}

/**
 * Check if a given object implements the LogoutCommand interface.
 */
export function instanceOfLogoutCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idToken" in value;
    isInstance = isInstance && "authorizationHeader" in value;
    isInstance = isInstance && "authMethod" in value;

    return isInstance;
}

export function LogoutCommandFromJSON(json: any): LogoutCommand {
    return LogoutCommandFromJSONTyped(json, false);
}

export function LogoutCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogoutCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idToken': json['IdToken'],
        'authorizationHeader': json['AuthorizationHeader'],
        'authMethod': json['AuthMethod'],
    };
}

export function LogoutCommandToJSON(value?: LogoutCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IdToken': value.idToken,
        'AuthorizationHeader': value.authorizationHeader,
        'AuthMethod': value.authMethod,
    };
}

